import { parse } from 'querystring';

export const getReferrerType = () => {
    if (typeof window === 'undefined') {
        return;
    }

    const searchString = window.location.search;
    const query = typeof searchString === 'string' ? searchString.slice(1) : '';
    const { referrerType, referrertype } = parse(query);
    return referrerType || referrertype;
};
